import React, { useEffect, useRef, useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { feedbackForEnrichedPhoneEmail } from "../../apis/ext";
import { useMutation } from "react-query";
import TooltipWrapper from "./TooltipWrapper";
import { toast } from "react-hot-toast";
import { useCaptureEvent } from "../../hooks/useCaptureEvent";
import Image from "../Tags/Image";

export default function EnrichedPhone({
  phoneValue,
  value,
  contactId = "",
  activeWorkspace,
  onSuccess,
  feedback = "",
  foundFrom = {},
  isValid = null,
  lineType = "",
  type = "",
  showDevider = true,
  advanceVerification = {},
  number = {},
}) {
  const captureEvent = useCaptureEvent();
  const [isCopied, setIsCopied] = useState(false);
  const [showCopy, setShowCopy] = useState(false);
  const copyText = (event, data) => {
    event.stopPropagation();
    event.preventDefault();
    let input = document.createElement("input");
    input.setAttribute("value", data);
    document.body.appendChild(input);
    input.select();
    let result = document.execCommand("copy");
    document.body.removeChild(input);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);

    return result;
  };
  const handleShowCopy = (mouseleave) => {
    if (mouseleave) {
      setShowCopy(false);
    } else {
      setShowCopy(true);
    }
  };
  const [showDropdown, setShowDropdown] = useState(false);
  const [isDropdownOpened, setIsDropdownOpened] = useState(false);

  useEffect(() => {
    if (isDropdownOpened) {
      setShowDropdown(true);
    } else {
      handleShowCopy(true);
      setShowDropdown(false);
    }
  }, [isDropdownOpened]);

  // give feedback for enriched phone

  const feedbackForEnrichedPhoneEmailFn = useMutation(
    "feedback_for_enriched_phone_email",
    feedbackForEnrichedPhoneEmail,
    {
      onSuccess(data, variables, context) {
        toast.success(data.message);
        onSuccess();
      },
      onError(error) {
        console.log(error);
      },
    }
  );

  const provideFeedback = (feedbackValue) => {
    if (feedbackForEnrichedPhoneEmailFn.isLoading) {
      return;
    } else {
      captureEvent("EXP_Person_FeedbackBtn", { feedback: feedbackValue });
      feedbackForEnrichedPhoneEmailFn.mutate({
        data: {
          contact_info_id: number?.id,
          // contact_id: contactId,
          feedback: feedbackValue,
          reason: "",
        },
        options: {
          headers: { "X-Workspace-Id": activeWorkspace?.id },
        },
      });
    }
  };

  const returnPhoneImg = (type) => {
    if (type === "Mobile") {
      return "/images/ext/phone.svg";
    } else if (type === "Direct") {
      return "/images/ext/direct-phone.svg";
    } else if (type === "Work HQ") {
      return "/images/ext/work-hq-phone.svg";
    } else if (type === "Other") {
      return "/images/ext/other-phone.svg";
    } else {
      return "/images/ext/other-phone.svg";
    }
  };

  const returnPhoneStatus = (normal = false) => {
    let obj = { img: "", tooltip: "" };
    if (
      advanceVerification &&
      advanceVerification.status === "Completed" &&
      isValid &&
      lineType === "Mobile"
    ) {
      if (advanceVerification.verification_status === "CONFIRMED_MATCH") {
        obj.img = "PrimeValid";
        obj.tooltip = "Ownership verified";
        return obj;
      }
      if (advanceVerification.verification_status === "LOW_CONFIDENCE_MATCH") {
        obj.img = "PrimeValidLow";
        obj.tooltip = "Likely belongs to user";
        return obj;
      }
      if (advanceVerification.verification_status === "NOT_A_MATCH") {
        obj.img = "PrimeInvalid";
        obj.tooltip = "Not the phone owner";
        return obj;
      }
      if (advanceVerification.verification_status === "CANNOT_DETERMINE") {
        obj.img = "PrimeUnknown";
        if (normal) {
          obj.img = "Valid";
        }
        obj.tooltip = "Cannot determine owner";
        return obj;
      }
    }
    if (isValid && lineType && lineType === "Mobile") {
      obj.img = "Valid";
      obj.tooltip = "Verified Number Type: Mobile";
      return obj;
    } else if (!isValid && isValid !== null) {
      obj.img = "Invalid";
      obj.tooltip = "Invalid";
      return obj;
    } else if (isValid && lineType && lineType !== "Mobile") {
      obj.img = "Risky";
      obj.tooltip = `Number was reported Mobile but found to be ${lineType}`;
      return obj;
    } else {
      return false;
    }
  };

  const [showAdvanceDetails, setShowAdvanceDetails] = useState(false);

  return (
    <>
      <div className="text-[12px] flex items-center  py-1.5 -ml-5 -mr-4 px-4 hover:bg-gray-100">
        <TooltipWrapper content={`${type} (${foundFrom?.name})`} className="flex">
          <span className="inline-flex w-8 text-center">
            <Image className="no-invert" src={returnPhoneImg(type)} alt="Phone" width={20} height={20} />
          </span>
        </TooltipWrapper>
        <div
          className={`enriched__phoneemail__hovercard__parent relative flex-1 ${
            showCopy ? "ellipsis_text_showcopy" : ""
          }`}
          onMouseEnter={() => {
            handleShowCopy(false);
            setShowDropdown(true);
          }}
          onMouseLeave={() => {
            if (isDropdownOpened && showDropdown) {
              setIsDropdownOpened(true);
              setShowDropdown(true);
            } else {
              setShowDropdown(false);
              handleShowCopy(true);
            }
          }}
        >
          <span
            className={`relative flex items-center group 
              ${
                feedback && feedback !== "Correct"
                  ? "line-through"
                  : `${!isValid && isValid !== null ? "line-through" : ""}`
              }
            ${
              advanceVerification?.status === "Pending" || advanceVerification?.status === "Processing"
                ? "flash-effect"
                : ""
            }
            `}
          >
            <span
              onClick={(e) => {
                copyText(e, value);
                captureEvent("EXP_Person_ClickToCopy", { type: "phone" });
              }}
              className="cursor-pointer text-[14px] text-brand-700 font-semibold custom__tooltip__parent"
            >
              {value}
              <span className="absolute  -top-8 left-10 w-[90px] custom__tooltip">
                {" "}
                {isCopied ? "Copied" : "Click to copy"}
              </span>
            </span>
            {returnPhoneStatus() && (
              <TooltipWrapper
                content={[
                  <div className="text-center py-0.5">
                    <p>{returnPhoneStatus().tooltip}</p>{" "}
                    {advanceVerification && advanceVerification.status === "Completed" && (
                      <span
                        className="cursor-pointer mt-0.5 block"
                        onClick={() => {
                          captureEvent("EXP_Person_ViewVerificationDetails", {
                            status: advanceVerification?.verification_status,
                          });
                          setShowAdvanceDetails(true);
                        }}
                      >
                        Click to learn more
                      </span>
                    )}{" "}
                  </div>,
                ]}
              >
                <Image
                  src={`/images/ext/mobile-status/${returnPhoneStatus(true).img}.svg`}
                  width={20}
                  height={20}
                  className="ml-2 w-[20px] h-[20px] no-invert"
                  onClick={() => {
                    advanceVerification &&
                      advanceVerification.status === "Completed" &&
                      setShowAdvanceDetails(true);
                    advanceVerification &&
                      captureEvent("EXP_Person_ViewVerificationDetails", {
                        status: advanceVerification?.verification_status,
                      });
                  }}
                />
              </TooltipWrapper>
            )}
            {showAdvanceDetails && (
              <div className="absolute top-[-60px] left-[-45px] z-[100] bg-background   rounded-xl p-4 w-[308px] animate__animated animate__fadeIn animate__faster">
                <div className="flex items-start w-full justify-between">
                  <p className="text-text-700 text-sm font-semibold mb-1">{value}</p>
                  <Image
                    className="cursor-pointer opacity-45 no-invert"
                    src="/images/ext/cross.svg"
                    alt="Cancel"
                    onClick={() => setShowAdvanceDetails(false)}
                  />
                </div>
                <div className="space-y-2 mt-2">
                  <div className="flex items-center w-full justify-between">
                    <span className="inline-flex items-center space-x-2">
                      <Image
                        className=" no-invert"
                        src={`/images/ext/mobile-status/${returnPhoneStatus().img}.svg`}
                        alt="Img"
                      />
                      <span className="text-text-700 text-xs font-semibold">
                        {returnPhoneStatus().tooltip}
                      </span>
                    </span>
                    <span className="text-xs">{advanceVerification?.verified_at}</span>
                  </div>
                  <div className="flex items-center w-full justify-between">
                    <span className="inline-flex items-center space-x-2">
                      <Image className=" no-invert" src={`/images/ext/mobile-status/Valid.svg`} alt="Img" />
                      <span className="text-text-700 text-xs font-semibold">Line type: Mobile</span>
                    </span>
                    <span className="text-xs">{advanceVerification?.verified_at_simple}</span>
                  </div>
                  <div className="flex items-center w-full justify-between">
                    <span className="inline-flex items-center space-x-2">
                      <Image className="no-invert"
                        src={`/images/ext/providers/${foundFrom?.key}.svg`}
                        alt=""
                        style={{ width: "auto", height: 19 }}
                      />
                      <span className="text-text-700 text-xs font-semibold">{foundFrom?.name}</span>
                    </span>
                    <span></span>
                  </div>
                </div>
              </div>
            )}
          </span>
          {showDropdown && (
            <div
              className="inline-block  bg-background rounded-lg px-3 py-2 animate__animated animate__fadeIn animate__faster enriched__phoneemail__hovercard"
              style={{ boxShadow: "0px 1px 3px var(--gray-400)" }}
            >
              <div className="flex w-full items-center space-x-3 enriched__phoneemail__hovercard__header">
                <span
                  className="inline-flex cursor-pointer"
                  onClick={(e) => {
                    copyText(e, value);
                    captureEvent("EXP_Person_CopyBtn", { type: "phone" });
                  }}
                >
                  {isCopied ? (
                    <Image className="no-invert" src="/images/ext/check.svg" width={17} height={17} />
                  ) : (
                    <Image className="no-invert" src="/images/ext/copy-paste-2.svg" width={17} height={17} />
                  )}
                </span>
                {/* <span className="inline-flex cursor-pointer">
                <Image className="no-invert" src="/images/ext/verify-gray-2.svg" width={17} height={17} />
              </span> */}
                {/* <span className="inline-flex cursor-pointer relative">
                  <Image className="no-invert" src="/images/ext/thumb-down.svg" width={17} height={17} />
                </span> */}
                {(showDropdown || feedbackForEnrichedPhoneEmailFn.isLoading) && (
                  <DropdownMenu open={isDropdownOpened} onOpenChange={(open) => setIsDropdownOpened(open)}>
                    <DropdownMenuTrigger className="ml-2 inline-flex focus:outline-none">
                      {!feedbackForEnrichedPhoneEmailFn.isLoading && (
                        <Image className="no-invert" src="/images/ext/thumb-down.svg" width={17} height={17} />
                      )}
                      {feedbackForEnrichedPhoneEmailFn.isLoading && (
                        <div className="loader_circle inline-block mr-1"></div>
                      )}
                    </DropdownMenuTrigger>
                    <DropdownMenuPortal>
                      <DropdownMenuContent className="w-full mt-1.5 ml-3" align="end">
                        <DropdownMenuGroup>
                          <DropdownMenuItem onClick={() => provideFeedback("Correct")}>
                            <Image src="/images/ext/thumb-up.svg" className="mr-2 no-invert" width={17} height={17} />
                            Correct
                          </DropdownMenuItem>
                          <DropdownMenuSub>
                            <DropdownMenuSubTrigger>
                              <Image
                                src="/images/ext/thumb-down.svg"
                                className="mr-2 no-invert"
                                width={17}
                                height={17}
                              />
                              Incorrect
                            </DropdownMenuSubTrigger>
                            <DropdownMenuSubContent>
                              <DropdownMenuItem onClick={() => provideFeedback("Wrong")}>
                                <img
                                  src={`/${process.env.REACT_APP_APP_HOME}/images/ext/cross-black.svg`}
                                  className="mr-2 no-invert"
                                  width={17}
                                  height={17}
                                />
                                Wrong
                              </DropdownMenuItem>
                              <DropdownMenuItem onClick={() => provideFeedback("Dead")}>
                                <img
                                  src={`/${process.env.REACT_APP_APP_HOME}/images/ext/emoticon-dead-outline.svg`}
                                  className="mr-2 no-invert"
                                  width={17}
                                  height={17}
                                />
                                Dead phone
                              </DropdownMenuItem>
                              <DropdownMenuItem onClick={() => provideFeedback("Other")}>
                                <img
                                  src={`/${process.env.REACT_APP_APP_HOME}/images/ext/info-question.svg`}
                                  className="mr-2 no-invert"
                                  width={17}
                                  height={17}
                                />
                                Other
                              </DropdownMenuItem>
                            </DropdownMenuSubContent>
                          </DropdownMenuSub>
                        </DropdownMenuGroup>
                      </DropdownMenuContent>
                    </DropdownMenuPortal>
                  </DropdownMenu>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {/* {showDevider && (
        <div class="w-[240px] h-[1px] bg-border mx-auto my-2"></div>
      )} */}
      {showAdvanceDetails && (
        <div
          className="bg__overlay"
          onClick={() => {
            setShowAdvanceDetails(false);
          }}
        ></div>
      )}
    </>
  );
}
